module.exports = __webpack_public_path__ + "static/media/avast-vince-shark.bb782132.jpg";